import { useEffect } from 'react';
import styled from 'styled-components';
import { useUserContextHook } from '../../hooks/useUserContextHook';
import ajexLogo from '../../assets/images/ajex_logo-1.png';

const PageWrapper = styled.div`
  min-height: 100vh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  font-family: 'Futura Std', 'FuturaStd-Medium', sans-serif;
`;

const Card = styled.div`
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-top: 4px solid #e8001c;
  border-radius: 4px;
  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.10);
  padding: 3.5rem 4rem;
  max-width: 900px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
`;

const WelcomeNotes = styled.div`
  margin-top: 2.5rem;
  width: 100%;
  background: #f9f9f9;
  border: 1px solid #e8e8e8;
  border-left: 4px solid #e8001c;
  border-radius: 2px;
  padding: 1.5rem 2rem;
`;

const WelcomeNotesTitle = styled.h3`
  color: #1a1a1a;
  font-size: 0.85rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin: 0 0 1rem 0;
`;

const WelcomeNotesList = styled.ul`
  margin: 0;
  padding: 0 0 0 1.2rem;
  color: #555555;
  font-size: 0.88rem;
  font-weight: 500;
  line-height: 1.8;
  letter-spacing: 0.01em;

  li {
    margin-bottom: 0.3rem;
  }
`;

const LogoWrapper = styled.div`
  margin-bottom: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Logo = styled.img`
  width: 280px;
  height: auto;
`;

const Divider = styled.div`
  width: 48px;
  height: 4px;
  background: #e8001c;
  border-radius: 2px;
  margin-bottom: 2rem;
`;

const Title = styled.h1`
  color: #1a1a1a;
  font-size: 2rem;
  font-weight: 800;
  letter-spacing: 0.01em;
  text-align: center;
  margin: 0 0 1rem 0;
  line-height: 1.2;
  text-transform: uppercase;
`;

const Subtitle = styled.p`
  color: #555555;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  margin: 0;
  line-height: 1.6;
  letter-spacing: 0.02em;
`;

const BadgeRow = styled.div`
  margin-top: 2.5rem;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
`;

const Badge = styled.div`
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 2px;
  padding: 0.5rem 1.2rem;
  font-size: 0.78rem;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

export const AimsOperationWelcome = () => {
  const { loadMasterDetails } = useUserContextHook();

  useEffect(() => {
    if (loadMasterDetails) {
      loadMasterDetails().catch((error) => {
        console.error("Failed to load master details:", error);
      });
    }
  }, [loadMasterDetails]);

  return (
    <PageWrapper>
      <Card style={{ width: "95%" }}  >
        {/* <LogoWrapper>
          <Logo src={ajexLogo} alt="AJEX Logo" />
        </LogoWrapper>
        <Divider /> */}
        <Title>AIMS Operation Portal</Title>
        <Subtitle>
          Select a module from the navigation menu to get started.
        </Subtitle>
        <BadgeRow>
          <Badge>Transport Management</Badge>
          <Badge>Operations</Badge>
          <Badge>Analytics</Badge>
        </BadgeRow>
        <WelcomeNotes>
          <WelcomeNotesTitle>Welcome To AIMS Operation Portal</WelcomeNotesTitle>
          <WelcomeNotesList>
            <li>Use the navigation menu on the left to access available modules.</li>
            {/* <li>Ensure all trip assignments are completed before end of shift.</li>
            <li>Contact the operations team for any system access issues.</li>
            <li>Data is refreshed in real-time — no need to reload the page manually.</li>
            <li>For support, reach out to the AIMS help desk via the internal portal.</li> */}
          </WelcomeNotesList>
        </WelcomeNotes>
      </Card>
    </PageWrapper>
  );
};
